import { formatTime } from "./formatTime";

export function areTimeDisplaysIdenticalAcrossTimezones(
  time: Date,
  timezone1: string,
  timezone2: string
): boolean {
  const timeString1 = formatTime(time, timezone1);
  const timeString2 = formatTime(time, timezone2);
  return timeString1 === timeString2;
}
